export default {"src":"/_next/static/media/us.946b364d.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};